import { useContext } from 'react';
import { ModalContext } from '../ModalOrchestratorProvider/ModalOrchestratorProvider.js';
import createModalStore from '../ModalStore/modalStore.js';

const stores = {};
const useModalStore = () => {
  // this hook will return a different store based on the context
  // we need different slides of the same MFE (eg activity picker,
  // to have one independent Zustand store by each Slide,
  // to avoid opening the same modal multiple time different instances
  // of the modal

  const modalContext = useContext(ModalContext);
  const storeKey = modalContext?.storeKey || 'default';
  if (!stores[storeKey]) {
    stores[storeKey] = createModalStore();
  }
  return stores[storeKey]();
};
var useModalStore$1 = useModalStore;

export { useModalStore$1 as default };
//# sourceMappingURL=useModalStore.js.map
